// @flow
import * as React from 'react';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';
import { suggestionsSelector } from '../../selectors';
import { searchParametersSelector } from '../../../Serp/selectors';
import type { SuggestionType } from '../../types/suggestion';
import { shuffleSuggestions, composeTranslatedSuggestionsPrefix } from '../../utils';
import SuggestionsList from '.';
import { verticalNameSelector } from '~/common/selectors/config';

type Props = {
  suggestions: ?Array<SuggestionType>,
  typeId: ?number,
  intl: IntlShape,
  verticalName: string,
};

type State = {
  suggestions: ?Array<SuggestionType>,
};

class InnerComponent extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      suggestions: [],
    };
  }

  componentWillMount() {
    // avoid conflicts with server side and client side diffing
    this.setState({
      suggestions: this.props.suggestions,
    });
  }

  componentDidMount() {
    const suggestions = shuffleSuggestions(this.props.suggestions || []);
    this.setState({ suggestions }); // eslint-disable-line react/no-did-mount-set-state
  }

  render() {
    const { intl, verticalName, typeId } = this.props;
    const { suggestions } = this.state;

    if (!suggestions || suggestions.length === 0) {
      return <div className="suggestionsPlaceholder" />;
    }

    const slicedSuggestions = suggestions.slice(0, 3);
    const suggestionsPrefix = composeTranslatedSuggestionsPrefix(intl, verticalName, typeId);

    return (
      <SuggestionsList suggestions={slicedSuggestions} suggestionsPrefix={suggestionsPrefix} />
    );
  }
}

function mapStateToProps(state) {
  const searchParameters = searchParametersSelector(state);

  return {
    suggestions: suggestionsSelector(state),
    verticalName: verticalNameSelector(state),
    typeId: get(searchParameters, 'type_id'),
  };
}

const SuggestionsListContainer = compose(
  connect(
    mapStateToProps,
    null
  ),
  injectIntl
)(InnerComponent);

SuggestionsListContainer.displayName = 'SuggestionsListContainer';

export default SuggestionsListContainer;



// WEBPACK FOOTER //
// ./app/Suggestions/components/SuggestionsList/container.js